// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"cb071d55","94":"acaf0200","276":"8a97d98d","457":"2fda420d","482":"ee5204e3","551":"1f88aab5","640":"0198cb28","713":"acaf0200","758":"0006055d","821":"428dfbbd","828":"7bac459a","907":"8333bda9"}[chunkId] + ".chunk.js";
};